import React from "react";
import { Label } from "../../components/ui/label";
import { Badge } from "../../components/ui/badge";

const Allergens = ({ updateData, t }) => {
  // Helper function to check if there are valid allergens
  const hasValidAllergens = () => {
    if (!updateData?.allergens || updateData.allergens === "") return false;

    try {
      const allergensList = JSON.parse(updateData.allergens);
      return Array.isArray(allergensList) && allergensList.length > 0;
    } catch (e) {
      return false;
    }
  };

  if (!hasValidAllergens()) return null;

  return (
    <div className="space-y-2 pt-5">
      <Label htmlFor="ingredients" className="text-right">
        {t("menu.allergens")}:
      </Label>
      <div className="grid grid-flow-col w-fit gap-2">
        {JSON.parse(updateData.allergens).map((item, index) => (
          <Badge
            key={index}
            className="p-2 text-sm bg-accent"
            variant="outline"
          >
            {item}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default Allergens;
